import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Divider, the hairline rule.
 *
 * CSS selector: `mobile/atoms.css` `.ds-divider` (+ `--strong`).
 *
 * Doctrine: depth comes from tone lift, not from lines, so dividers stay
 * hairline thin. `soft` separates items inside one group and is the default;
 * `strong` marks a structural split between sections, such as the rule above a
 * total row on a receipt.
 */
const DIVIDER_WEIGHT = {
  soft: null,
  strong: 'ds-divider--strong',
};

export const Divider = React.forwardRef(function Divider(
  { className, weight = 'soft', ...rest },
  ref,
) {
  return <hr ref={ref} className={cn('ds-divider', DIVIDER_WEIGHT[weight], className)} {...rest} />;
});

export default Divider;
